import { ForgotPasswordComponent } from './views/forgot-password/forgot-password.component';
import { HomeComponent } from './views/main/home/home.component';
import { LoginComponent } from './views/login/login.component';
import { MainComponent } from './views/main/main.component';
import { PetDetailsComponent } from './views/main/pet-details/pet-details.component';
import { ProfileComponent } from './views/main/profile/profile.component';
import { ResetPasswordComponent } from './views/reset-password/reset-password.component';
import { Routes } from '@angular/router';
import { UserType } from './shared/models/user.model';
import { authenticationGuard } from './config/auth/authentication.guard';
import { authorizationGuard } from './config/auth/authorization.guard';
import { petResolver } from './shared/resolvers/pet/pet.resolver';
import { qrCodeResolver } from './shared/resolvers/qr-code/qr-code.resolver';
import { userResolver } from './shared/resolvers/user/user.resolver';

const { ADMIN, USER } = UserType;
export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
  },
  {
    path: 'register',
    loadComponent: () => import('./views/registration/registration.component').then(m => m.RegistrationComponent),
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [authenticationGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [authorizationGuard],
        data: { roles: [USER] }
      },
      {
        path: 'control-panel',
        loadComponent: () => import('./views/main/admin-panel/admin-panel.component').then(m => m.AdminPanelComponent),
        canActivate: [authorizationGuard],
        data: { roles: [ADMIN] }
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [authorizationGuard],
        data: { roles: [USER] }
      },
      {
        path: 'pet/:petId',
        component: PetDetailsComponent,
        canActivate: [authorizationGuard],
        data: { roles: [USER] },
        resolve: { pet: petResolver }
      },
    ]
  },
  {
    path: 'code/:qrCodeId',
    loadComponent: () => import('./views/qr-code/qr-code.component').then(m => m.QrCodeComponent),
    resolve: {
      qrCode: qrCodeResolver,
      user: userResolver
    }
  },
  {
    path: 'not-found',
    loadComponent: () => import('./views/not-found/not-found.component').then(m => m.NotFoundComponent),
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];
